/* 2TAC Emergency Power Bank page (section power-bank-ver1).
   One start(root) per section; restarts when the theme editor reloads the section. */
(function () {
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function start(root) {
    if (!root || root.dataset.pbReady) return;
    root.dataset.pbReady = "1";
    var cleanups = [];
    root._pbStop = function () { cleanups.forEach(function (fn) { try { fn(); } catch (e) {} }); delete root.dataset.pbReady; };
    var hasIO = "IntersectionObserver" in window;

    /* gallery */
    var main = $(".gal__main img", root), thumbs = $$(".gal__thumbs button", root), cur = 0;
    function show(i) {
      if (!thumbs.length || !main) return;
      cur = (i + thumbs.length) % thumbs.length;
      var t = thumbs[cur];
      main.src = t.dataset.full;
      if (t.dataset.srcset) main.srcset = t.dataset.srcset; else main.removeAttribute("srcset");
      main.alt = t.dataset.alt || "";
      thumbs.forEach(function (b, k) { b.setAttribute("aria-current", k === cur ? "true" : "false"); });
      var strip = t.parentNode;
      strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, behavior: "smooth" });
    }
    thumbs.forEach(function (b, i) { b.addEventListener("click", function () { show(i); }); });
    var prev = $(".gal__prev", root), next = $(".gal__next", root);
    prev && prev.addEventListener("click", function () { show(cur - 1); });
    next && next.addEventListener("click", function () { show(cur + 1); });
    if (main) {
      var sx = null;
      main.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener("touchend", function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }
    root._pbShow = show;

    /* every extra buy button submits the main product form (theme cart drawer opens) */
    var form = $(".pb-form", root);
    $$("[data-pb-atc]", root).forEach(function (b) {
      b.addEventListener("click", function () {
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    });

    /* clips: muted autoplay while on screen, tap one for sound */
    var clips = $$(".vids video", root);
    if (hasIO && clips.length) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); });
      }, { threshold: 0.35 });
      clips.forEach(function (v) { cio.observe(v); });
      cleanups.push(function () { cio.disconnect(); });
    }
    clips.forEach(function (v) {
      v.parentNode.addEventListener("click", function () {
        var on = v.muted;
        clips.forEach(function (o) { o.muted = true; o.parentNode.classList.remove("on"); });
        v.muted = !on; v.parentNode.classList.toggle("on", on); v.play().catch(function () {});
      });
    });

    /* before / after */
    var ba = $(".ba", root), range = ba && $("input", ba);
    range && range.addEventListener("input", function () { ba.style.setProperty("--pos", range.value + "%"); });

    /* numbers: count up and play the product clip while on screen */
    var video = $(".nb__art video", root), counters = $$("[data-count]", root);
    if (hasIO) {
      counters.forEach(function (el) { el.textContent = "0"; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.target === video) { if (e.isIntersecting) video.play().catch(function () {}); else video.pause(); return; }
          if (!e.isIntersecting) return;
          var el = e.target, end = +el.dataset.count, t0 = null;
          io.unobserve(el);
          requestAnimationFrame(function step(t) {
            if (!t0) t0 = t;
            var p = Math.min(1, (t - t0) / 1800);
            el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
            if (p < 1) requestAnimationFrame(step);
          });
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { io.observe(el); });
      video && io.observe(video);
      cleanups.push(function () { io.disconnect(); });
    }

    /* reviews carousel arrows */
    var rt = $(".rtrack", root);
    function rstep(d) { var c = rt && $(".rcard", rt); if (c) rt.scrollBy({ left: d * (c.offsetWidth + 18), behavior: "smooth" }); }
    var rp = $(".rnav [data-dir='-1']", root), rn = $(".rnav [data-dir='1']", root);
    rp && rp.addEventListener("click", function () { rstep(-1); });
    rn && rn.addEventListener("click", function () { rstep(1); });

    /* sticky add to cart, shown once the main button scrolls away */
    var sticky = $(".sticky", root), atc = $(".pb-atc-main", root);
    if (sticky && atc && hasIO) {
      var sbtn = $(".pb-btn", sticky);
      var sio = new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle("show", past);
        sticky.setAttribute("aria-hidden", past ? "false" : "true");
        if (sbtn) sbtn.tabIndex = past ? 0 : -1;
      });
      sio.observe(atc);
      cleanups.push(function () { sio.disconnect(); sticky.classList.remove("show"); });
    }
  }

  function startAll() { $$(".pbv1").forEach(start); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", startAll); else startAll();

  /* theme editor */
  document.addEventListener("shopify:section:load", function (e) { start($(".pbv1", e.target)); });
  document.addEventListener("shopify:section:unload", function (e) { var r = $(".pbv1", e.target); if (r && r._pbStop) r._pbStop(); });
  document.addEventListener("shopify:block:select", function (e) {
    var b = e.target, r = b.closest && b.closest(".pbv1");
    if (!r) return;
    if (b.matches && b.matches(".gal__thumbs button") && r._pbShow) r._pbShow($$(".gal__thumbs button", r).indexOf(b));
    if (b.scrollIntoView) b.scrollIntoView({ block: "nearest", inline: "center" });
  });
})();
